/** 同一未确认发送保留幂等键；成功后清除，下一条相同文字仍是新消息。 */
export function legacyChatAttempt(target, content, receiver) {
  const fingerprint = JSON.stringify([target.sessionId, String(receiver), content]);
  if (target.legacySendAttempt?.fingerprint !== fingerprint) target.legacySendAttempt = {
    fingerprint, clientMessageId: globalThis.crypto?.randomUUID?.() || `chat_${Date.now()}_${Math.random().toString(36).slice(2)}`,
  };
  return target.legacySendAttempt.clientMessageId;
}
export function confirmLegacyChatAttempt(target, clientMessageId) {
  if (target.legacySendAttempt?.clientMessageId === clientMessageId) target.legacySendAttempt = null;
}
/** 删除/撤权使同一会话的在途读取失效，不能把旧轮正文重新填回窗口。 */
export function applyLegacyResourceEvent(target, event) {
  if (!target || String(target.sessionId) !== String(event.resourceId) || !["resource.deleted", "resource.revoked"].includes(event.eventType)) return;
  target.messages = []; target.lastMessageId = 0; target.stableSequenceCursor = "0"; target.sequenceEpoch = null;
  target.lastReadSequence = null;
  target.syncEpoch = (target.syncEpoch || 0) + 1;
}
